import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getTeamMember, updateTeamMember } from "adminApi/TeamListApi/TeamList";
import { validateForm } from "utils/validation";
import { TeamRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditTeamMemberForm from "./Componates/TeamMemberEditForm";
import fields from "../json/TeamMemberList.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const TeamMemberEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  // ✅ Initialize default form values
  const initialValues = formdata.reduce(
    (acc, field) => ({ ...acc, [field.name]: "" }),
    {}
  );

  // ✅ Hook for managing form data
  const { values, errors, handleChange, handleFileChange, setValues, setErrors } =
    useFormChange(initialValues, TeamRules);

  // ✅ Fetch existing data by ID
  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    formdata,
    getTeamMember,
    setValues
  );

  // ✅ Handle submit using shared submit hook
  const { loading, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => {
        formData.append(key, val ?? "");
      });
      return await updateTeamMember({ id, data: formData });
    },
    (vals) => {
      // Remove preview and avoid resubmitting existing image path string
      if (typeof vals.photograph === "string") {
        delete vals.photograph;
      }
      delete vals.photographPreview;

      const err = validateForm(vals, TeamRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Team Member updated successfully"
  );

  return (
    <>
      {(loading || loadingFetch) && <Spinner isSpinner={true} />}
      <EditTeamMemberForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        imagePreview={
          values.photographPreview ||
          (values.photograph && values.photograph)
        }
        loading={loading}
        title="Update Team Member"
      />
    </>
  );
};

export default TeamMemberEdit;
